module.exports = __webpack_public_path__ + "static/Roboto-Medium-d52f011be65b281ba8ca1c3f689cf133.ttf";